<template>

   <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

            <v-card v-model="level.dialogValues.dialogShow" data-app="true" >

               <CardUpdatableHeader :row="row" :level="level"/>

               <v-card-text>

                  <v-container>

                     <v-row>
                        <v-col cols="12" sm="6">
                           <v-text-field v-model="row.inv_code" :disabled="level.dialogValues.form_disabled" outlined :label="$t('texts.inv_code')">
                           </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                           <v-text-field v-model="row.cus_name" :disabled="level.dialogValues.form_disabled" :label="$t('texts.cus_name')" :hint="$t('hints.cus_name')"></v-text-field>
                        </v-col>
                     </v-row>

                     <v-row>
                        <v-col v-if="!level.dialogValues.form_create" cols="12">
                           <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.inv_create,'long') }}<br/>
                           <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.inv_create,'long') }}
                        </v-col>
                     </v-row>

                  </v-container>
                  <small>*{{ $t('texts.requiredfield') }}</small>
               </v-card-text>

               <CardUpdatableFooter :row="row" :level="level"/>

            </v-card>

   </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';

export default {
   name: 'CardUpdatableInvoice',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      ddoWaiting,
      CardUpdatableHeader,
      CardUpdatableFooter,
   },

   props: {
   },

   data: function () {
      return {
         show: false,
         loading: false,
      }
    },

   created() {
   },

   methods: {
   },
}
</script>